export const Colors = {
  white: "#FFFFFF",
  black: "#000000",
  whiteSmoke: "#f3f3f3",
  lightWhiteSmoke: "#f6f6f6",
  blackSqueeze: "#FCFDFE",
  mischkaApprox: "#CDCFD9",
  santasGray: "#9FA2B4",
  coralRedApprox: "#FF333F",
  secondaryBlack: "#333333",
  dustyGray: "#999999",
  zirconApprox: "#F5F8FF",
  selagoApprox: "#EFF2FC",
  aqua: "#0a0f81",
  electricBlue: "#034573",
  darkBlue: "#0261a3",
  darkGrey: "#9f9f9f",
  chineeseSilver: "#ccc",
  grey: "#9a9a9a",
  approxSnow: "#fafafa",
  approxCellow: "#405262",
  darkCharcoal: "#333",
  grey40: "#666666",
  grey10: "#a1c0e11a",
  veryDarkBlue: "#070127",
  arsenic: "#3c4242",
  cyan: "#0a0f81",
  rainbowGrey: "#bebcbd",
  approxGrey: "#807d7e",
  davyGrey: "#525c60",
  lightBlack: "rgba(0, 0, 0, 0.35)",
  lightBlack2: "rgba(0, 0, 0, 0.2)",
  lightBlack3: "rgba(0, 0, 0, 0.9)",
  lightBlack4: "rgba(0, 0, 0, 0.6)",
  blackWithZeroOpacity: "rgba(0, 0, 0, 0)",
  lightBlack5: "rgba(0, 0, 0, 0.1)",
  mediumTorquoise: "#33cccc",
  blackOpacity: "rgba(0, 0, 0, 0.7)",
  transperant: "#00000000",
  darkRed: "#cd512c",
  lightGrey: "#7b7b7b",
  greenlandGreen: "#23AFAF",
  lightBlack4: "#2B2B2B",
  aquaGreen: "#11a491",
  maroonRed: "#C73232",
  barberryYellow: "#f4c031",
  doveGrey: "#717171",
  darkShadeGreywithOpacity: "rgba(46, 46, 46, 0.1)",
  veryDrakGrey: "#454545",
  darkishBlue: "#20232b",
  lightishGrey: "#F7F8FA",
  mediumBlue: "#505470",
  lightShadeBlue: "#EFF0F4",
  red: "#EA3323",
  lightBlue: "#467CF8",
  orange: "#F39E1A",
  bgGrey: "#ECECEC",
  ePink: "#169191",
  lineBlack:"#B8B8B8",
  e8Grey: "#E8E8E8",
  parrotGreen: "#57B379",
  //LWW Changes
  lwwTextColor: '#040404',
  lightAqua: '#78b1c5'
};
